export class InformarAcus { 
    expedient: number
    tipus: string
    data: Date
    esAcceptada: boolean
}